import React from "react";

import { round6 } from "components/utils/mapa/useUbicacion";

import EstablecimientoVista from "./EstablecimientoVista";

/**
 * Modal de consulta de un establecimiento, compartido por las cinco entidades.
 *
 * Trae el registro y se lo pasa a la vista. Las cuatro entidades simples lo usan tal cual —sus
 * ViewModal son un reexport de este archivo— y hospitales le suma sus campos propios por
 * `camposExtra` y `valoresExtra`.
 *
 * Los valores salen de la FILA de la grilla, que ya trae todo lo que se muestra aca. No
 * hay Get propio: seria una request para releer lo que la lista acaba de traer.
 *
 * @param camposExtra  reemplaza a nombre y codigo al principio de la grilla, cuando la entidad
 *                     tiene campos propios que intercalar.
 * @param valoresExtra recibe la FILA y devuelve los valores de esos campos.
 */
export default function VistaModal({
    row,
    closeModal,
    camposExtra = null,
    valoresExtra = () => ({}),
    columnas = null,
    mapaAncho = true,
}) {
    const valores = {
        cod: row.cod ?? "",
        name: row.name ?? "",
        calle: row.calle ?? "",
        numero: row.numero ?? "",
        cpa: row.cpa ?? "",
        // El nombre y no el id: en la consulta la localidad es un texto, no un select.
        localidad: row.localidad ?? "",
        // Con los mismos seis decimales que muestra el formulario, para que el mismo
        // registro no se lea distinto segun por donde se lo abra.
        lat: row.lat ? round6(row.lat) : "",
        lng: row.lng ? round6(row.lng) : "",
        ...valoresExtra(row),
    };

    return (
        <EstablecimientoVista
            valores={valores}
            closeModal={closeModal}
            camposExtra={camposExtra}
            columnas={columnas}
            mapaAncho={mapaAncho}
        />
    );
}
